'use client'

import { Box } from '@mui/material'
import { useTranslations } from 'next-intl'

import { useGateValue } from '~/configs/statsig'

import BillingCompletenessCard from './BillingCompletenessCard'
import { useOptionalBillingComposer } from './BillingComposerProvider'
import ComposeWithAgentButton from './ComposeWithAgentButton'
import { useBillingSetupCardItems } from './useBillingSetupCompleteness'

/**
 * "Billing setup" card for the billing and tax hubs: the client-side completeness checklist with a
 * "Fix with Agent" button that opens the composer in general mode on the first gap. Renders nothing
 * (and fetches nothing) unless both the `billing-composer` and `ai-assistant` gates are on — including
 * no spacer — so hubs do not leave a blank gap when the gate is off.
 */
export default function BillingSetupSection() {
  const composerEnabled = useGateValue('billing-composer')
  const assistantEnabled = useGateValue('ai-assistant')
  if (!composerEnabled || !assistantEnabled) return null
  return (
    <Box sx={{ mb: 3 }}>
      <BillingSetupCard />
    </Box>
  )
}

function BillingSetupCard() {
  const t = useTranslations('features.BillingComposer')
  const composer = useOptionalBillingComposer()
  const { score, items, isLoading } = useBillingSetupCardItems()

  const firstGap = items.find((item) => item.status !== 'done')
  const prompt = firstGap ? t('fix_promptWithGap', { gap: firstGap.message }) : t('prompt_general_1')

  return (
    <BillingCompletenessCard
      score={score}
      items={items}
      isLoading={isLoading}
      collapsible
      action={composer?.enabled ? <ComposeWithAgentButton label={t('button_fix')} prompt={prompt} /> : undefined}
    />
  )
}
